import { Address } from '@api/interfaces';
import { formatLocaleDate } from '@helpers/dateHelpers';

const emptyValue = '-';

export const formatProfileDate = (
  value: string | null | undefined
): string => {
  if (!value) {
    return emptyValue;
  }

  const [year, month, day] = value.split('-').map(Number);

  if (!year || !month || !day) {
    return emptyValue;
  }

  return formatLocaleDate(new Date(year, month - 1, day), false);
};

export const formatProfileStreet = (address: Address | null): string => {
  if (!address) {
    return emptyValue;
  }

  const suffix = address.houseNumberSuffix ?? '';

  return `${address.street} ${address.houseNumber}${suffix}`.trim();
};

export const displayProfileValue = (
  value: string | null | undefined
): string => {
  if (!value) {
    return emptyValue;
  }

  return value;
};
